import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { PopupService } from "src/app/services/popup.service";
import { MESSAGES } from "../shared/constants/common.constants";

@Injectable({
  providedIn: 'root'
})
export class ConnectivityService {
  private connectionStatus = new BehaviorSubject<boolean>(navigator.onLine);
  public connectionStatus$ = this.connectionStatus.asObservable();

  constructor(private popUpService: PopupService) {
    this.monitorNetwork();
  }

  private monitorNetwork() {
    window.addEventListener('online', () => {
      this.updateNetworkStatus(true);
    });

    window.addEventListener('offline', () => {
      this.updateNetworkStatus(false);
    });
  }

  private updateNetworkStatus(isOnline: boolean) {
    this.connectionStatus.next(isOnline);
    if (isOnline) {
      this.popUpService.messsageAlert('success', MESSAGES.INTERNET_RESTORED);
    } else {
      this.popUpService.messsageAlert('error', MESSAGES.INTERNET_DISCONNECTED);
    }
  }
}